export type MailboxCaptureAvailability={
 active?:boolean;sync_enabled:boolean;mailbox_scope_verified_at?:string;
 connector_configured:boolean;storage_configured:boolean;last_sync_error_code?:string;
 reauthorisation_required?:boolean;businessAuthorised?:boolean;
};
/** A saved per-mailbox switch is not proof that the collection worker is enabled. */
export function mailboxCapturePresentation(account:MailboxCaptureAvailability){
 if(account.active===false)return {label:'Disabled',tone:'warning'};
 if(account.last_sync_error_code||account.reauthorisation_required||account.businessAuthorised===false||!account.storage_configured)
  return {label:'Needs attention',tone:'warning'};
 if(!account.mailbox_scope_verified_at)return {label:'Needs attention',tone:'warning'};
 if(!account.connector_configured||!account.sync_enabled)return {label:'Paused',tone:'warning'};
 return {label:'Active',tone:'success-badge'};
}
